import InvoiceApiClient from "./base";

// Gmail Settings API
export const gmailSettingsApi = {
  // Get all Gmail settings
  getAllSettings: () => {
    return InvoiceApiClient.get("/gmail/settings");
  },

  // Get specific Gmail setting by ID
  getSetting: (settingId) => {
    return InvoiceApiClient.get(`/gmail/settings/${settingId}`);
  },

  // Get Gmail setting by order place
  getSettingByOrderPlace: (orderPlace) => {
    return InvoiceApiClient.get(`/gmail/settings/order-place/${orderPlace}`);
  },

  // Create new Gmail setting
  createSetting: (settingData) => {
    return InvoiceApiClient.post("/gmail/settings", settingData);
  },

  // Update existing Gmail setting
  updateSetting: (settingId, updateData) => {
    return InvoiceApiClient.put(`/gmail/settings/${settingId}`, updateData);
  },

  // Delete Gmail setting
  deleteSetting: (settingId) => {
    return InvoiceApiClient.delete(`/gmail/settings/${settingId}`);
  },

  // Toggle active status
  toggleSetting: (settingId) => {
    return InvoiceApiClient.put(`/gmail/settings/${settingId}/toggle`);
  },

  // Search Gmail using settings
  searchGmail: (searchRequest) => {
    return InvoiceApiClient.post("/gmail/search", searchRequest);
  },

  // Test Gmail mapping.
  // When downloadInvoice is true, the server may return a PDF blob (ephemeral).
  testMapping: (orderPlace, invoice_number, query, downloadInvoice = false) => {
    return InvoiceApiClient.get(`/gmail/test/${orderPlace}`, {
      params: {
        invoice_number,
        query,
        download_invoice: downloadInvoice,
      },
      ...(downloadInvoice ? { responseType: "blob" } : {}),
    });
  },

  // Get available order places
  getOrderPlaces: () => {
    return InvoiceApiClient.get("/gmail/settings/order-places");
  },

  // Get only active settings
  getActiveSettings: () => {
    return InvoiceApiClient.get("/gmail/settings/active");
  },
};
